<template>
  <a-modal
    v-model="visible"
    :title="title"
    width="10cm"

    :maskClosable="false"
    footer="">
    <Calculator>
    </Calculator>
  </a-modal>
</template>

<script>
import Calculator from '../Calculator/Calculator'

export default {
    name: 'CalculatorModal',
    components:{
      Calculator
    },
    data () {
      return {
        visible: false,
        title:'计算器'
      }
    },
  }
</script>

<style scoped>

</style>